// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const config = {
  'handshakeUrl': 'https://dl8xj8lzti.execute-api.us-west-2.amazonaws.com/dev/handshake',
  'carrierLogoUrl': 'https://d2dsonw47v78oa.cloudfront.net/static/source/',
  'defaultSource': 'default',
  'defaultProgressiveSource':'583',
  'brandInfoUrl': 'https://dl8xj8lzti.execute-api.us-west-2.amazonaws.com/dev/source/',
  'defaultZip': '00000',
  'defaultCampaign': 'default',
  'progressiveSourcePageTitle':'Progressive Life by eFinancial',
  'fidelitySourcePageTitle':'Online Digital Experience',
  'tagManagerCode': 'GTM-55Q528VM',
  'tagManagerEnv': '&gtm_auth=JxBjvkZyFwvsJH2xyONB5w&gtm_preview=env-6&gtm_cookies_win=x',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
